<template lang="pug">
v-container(fluid fill-height)
  v-layout(align-center justify-center)
    v-flex(xs12 sm8 md6 lg4)
      v-card.pa-6(elevation="4" style="border-radius: 24px;")
        v-layout(column align-center)
          v-icon(size="64" color="primary") mdi-cards
          .display-1.mt-4.mb-2.text-center
            span Pap
            span(style="color: #36454F; font-weight: 700; font-style: italic; font-family: 'Cinzel', serif; font-size: 1.2em;") A
            span(style="color: #36454F; font-weight: 600; font-style: italic; font-family: 'Cinzel', serif;") rtisan
          .subtitle-1.grey--text.text-center.mb-4 Your card game design tool
          v-divider.mb-4
          .body-1.text-center.mb-4 Design, iterate, and print your card games - with inline icons, rich text formatting, and Google Drive sync.

          //- Animated demo table
          v-card.mb-4(outlined style="border-radius: 12px; width: 100%; overflow: hidden;")
            v-simple-table(dense)
              template(v-slot:default)
                thead
                  tr
                    th(style="font-family: 'Josefin Sans'; font-size: 11px; opacity: 0.6; width: 50%;") Spreadsheet input
                    th(style="font-family: 'Josefin Sans'; font-size: 11px; opacity: 0.6; width: 50%;") Card output
                tbody
                  tr
                    td
                      transition(name="fade" mode="out-in")
                        span(
                          :key="currentExample.input"
                          style="font-family: 'courier'; font-size: 13px;"
                        ) {{ currentExample.input }}
                    td
                      transition(name="fade" mode="out-in")
                        span(
                          :key="currentExample.input"
                          style="font-size: 14px;"
                          v-html="currentExample.output"
                        )

          
          .body-2.grey--text.text-center.mb-4 Sign in with your Google account to get started. Your designs are stored safely in your own Google Drive.
          v-btn(color="primary" large rounded @click="login")
            v-icon(left) mdi-google
            | Sign in with Google
          v-alert(v-if="loginError" type="error" class="mt-4") {{ errorMessage }}
          v-divider.mt-6.mb-4
          .caption.grey--text.text-center
            | Built on the foundations of 
            a(href="https://beta.editor.paperize.io" target="_blank" style="color: inherit;") Paperize.io
            |  - support them on 
            a(href="https://www.patreon.com/paperize" target="_blank" style="color: inherit;") Patreon
            |  and join their 
            a(href="https://discord.gg/9ggkkQp" target="_blank" style="color: inherit;") Discord
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  const ERROR_CODE_MAP = {
    popup_closed_by_user: "You closed the pop-up without logging in.",
    popup_blocked_by_browser: "Your browser blocked the login pop-up. Enable pop-ups for this site and try again!",
    access_denied: "You denied PapArtisan access. It cannot run without a linked Google account.",
  }

  const EXAMPLES = [
    {
      input: 'Deal [b:3] damage',
      output: 'Deal <strong>3</strong> damage'
    },
    {
      input: '[i:Legendary] card',
      output: '<em>Legendary</em> card'
    },
    {
      input: '[c:red:Fire] strike',
      output: '<span style="color:#DC3232">Fire</span> strike'
    },
    {
      input: '[bic:purple:Critical Hit!]',
      output: '<strong><em><span style="color:#9632BE">Critical Hit!</span></em></strong>'
    },
    {
      input: '[bc:blue:Frost] damage',
      output: '<strong><span style="color:#3264BE">Frost</span></strong> damage'
    },
    {
      input: 'Deal [icon:sword.png] damage',
      output: 'Deal ⚔ damage'
    },
    {
      input: '[c:green:Heal] [icon:heart.png]',
      output: '<span style="color:#32BE32">Heal</span> ❤'
    },
  ]

  export default {
    data() {
      return {
        currentIndex: 0,
        timer: null,
        clientId: '546687505081-604g1hvp707h0n6ad8gvhm3lnvq55emp.apps.googleusercontent.com'
      }
    },
    computed: {
      ...mapGetters(['loginError']),
      currentExample() {
        return EXAMPLES[this.currentIndex]
      },
      errorMessage() {
        return ERROR_CODE_MAP[this.loginError] || `There was an error logging in: ${this.loginError}`
      }
    },
    mounted() {
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % EXAMPLES.length
      }, 3000)

      // Set up the One Tap callback
      window.handleGoogleOneTap = (response) => {
        if (response && response.credential) {
          this.$store.dispatch('login')
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.timer)
      delete window.handleGoogleOneTap
    },
    methods: {
      ...mapActions(['login'])
    }
  }
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.6s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>